import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { HoverDeleteButton } from "@scripts/react/components/Button";
import { twClassNames } from "@scripts/react/helpers/twClassNames";
import {
    useDraggableCard,
    DRAGGABLE_CARD_ANIMATION,
    DRAGGABLE_CARD_CLASSES,
    DEFAULT_CARD_WIDTH
} from "@rapid/hooks/useDraggableCard";

interface ContextualHintCardProps {
    isOpen: boolean;
    onClose: () => void;
    children: React.ReactNode;
    anchorElement?: HTMLElement | null;
    cardWidth?: number;
    className?: string;
}

export function ContextualHintCard({
    isOpen,
    onClose,
    children,
    anchorElement,
    cardWidth = DEFAULT_CARD_WIDTH,
    className
}: ContextualHintCardProps) {
    const { position, cardRef, startDrag } = useDraggableCard({ isOpen, anchorElement, cardWidth });

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    ref={cardRef}
                    className={twClassNames(DRAGGABLE_CARD_CLASSES, "p-4", className)}
                    style={{ left: position.left, top: position.top, width: cardWidth }}
                    onMouseDown={startDrag}
                    {...DRAGGABLE_CARD_ANIMATION}
                >
                    {children}

                    {/* @ts-expect-error - HoverDeleteButton type mismatch with JSX.Element */}
                    <HoverDeleteButton
                        onClick={onClose}
                        ariaLabel="Close card"
                        className="-right-1 -top-1"
                    />
                </motion.div>
            )}
        </AnimatePresence>
    );
}
